import { Box, DialogContent, Divider } from '@mui/material';
import React from 'react';

import useScreenSize from '../../../utils/useScreenSize';
import type { PlanSetting } from '../ManageSubscriptionDialog';
import PlanSettings from '../PlanSettings';

interface ManageSubscriptionDialogContentProps {
	columns: PlanSetting[];
}

const ManageSubscriptionDialogContent: React.FC<ManageSubscriptionDialogContentProps> = (props) => {
	const { columns } = props;
	const { isMdScreen, isLgScreen } = useScreenSize();
	const isDesktopScreen = isMdScreen || isLgScreen;

	return (
		<DialogContent sx={{ p: 0 }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: isDesktopScreen ? 'row' : 'column',
					alignSelf: 'stretch',
					alignItems: 'stretch',
					justifyContent: 'space-evenly',
				}}
			>
				{columns.map((column, index) => (
					<React.Fragment key={column.id}>
						<PlanSettings
							title={column.title}
							description={column.description}
							sxProps={columns.length === 1 ? { width: 'auto' } : undefined}
							button={{
								text: column.buttonText,
								variant: column.buttonVariant,
								color: column.buttonColor,
								onClick: column.onClick,
								sx: column.buttonSx,
							}}
							Icon={column.Icon}
						/>
						{column.showDivider && index < columns.length - 1 && (
							<Divider orientation={isDesktopScreen ? 'vertical' : 'horizontal'} flexItem />
						)}
					</React.Fragment>
				))}
			</Box>
		</DialogContent>
	);
};

export default ManageSubscriptionDialogContent;
